const styles = {
  fullWidthDivider: {
    marginRight: '-24px',
    marginLeft: '-24px',
    width: 'calc(100% + 48px)'
  }
}

export default styles
